import { render, staticRenderFns } from "./SimilarAdvertisement.vue?vue&type=template&id=3c05f548&scoped=true&"
import script from "./SimilarAdvertisement.vue?vue&type=script&lang=js&"
export * from "./SimilarAdvertisement.vue?vue&type=script&lang=js&"
import style0 from "./SimilarAdvertisement.vue?vue&type=style&index=0&id=3c05f548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c05f548",
  null
  
)

export default component.exports